import { render, staticRenderFns } from "./PostFeedbackSuccess.vue?vue&type=template&id=c318d0ae&lang=pug"
import script from "./PostFeedbackSuccess.vue?vue&type=script&lang=js"
export * from "./PostFeedbackSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports